import type { ProblemDetails } from '../contracts/problemDetails'
import { ApiError } from './ApiError'

function asProblemDetails(payload: unknown): ProblemDetails {
  return payload && typeof payload === 'object' ? payload as ProblemDetails : {}
}

function normalizeFieldErrors(errors: ProblemDetails['errors']) {
  if (!errors) return {}
  return Object.fromEntries(Object.entries(errors).map(([field, messages]) => [
    field,
    Array.isArray(messages) ? messages.map(String) : [String(messages)],
  ]))
}

export function mapApiError(status: number, payload: unknown): ApiError {
  const problem = asProblemDetails(payload)
  const fieldErrors = normalizeFieldErrors(problem.errors)
  const message = problem.detail ?? problem.message ?? problem.title ?? 'The request could not be completed.'

  if (status === 400 || status === 422) return new ApiError('validation', message, status, fieldErrors)
  if (status === 401) return new ApiError('unauthorized', message, status)
  if (status === 403) return new ApiError('forbidden', message, status)
  if (status === 404) return new ApiError('not-found', message, status)
  if (status === 409) return new ApiError('conflict', message, status)
  if (status >= 500) return new ApiError('server', 'The server could not complete the request.', status)
  return new ApiError('unknown', message, status, fieldErrors)
}
